import { useEffect, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, TextField, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left";
import TenderIfo from "./TenderInfo";
import InfoCircle from "../../../../media/images/icons/info-circle";
import BigCar3 from "../../../../media/images/icons/bigcar3";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import DolorSingle from "../../../../media/images/icons/dolor-single";
import ArrowUpFillSVG from "../../../../media/images/icons/arrow-up";
import CustomButton from "../../../components/CustomButton";
import MultipleSimple from "../../../../media/images/icons/multiple-simple";
import EditFillSVG from "../../../../media/images/icons/editfill-icon";
import { useParams } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import RemoveTenderModal from "./RemoveTenderModal";
export interface ITenderOfferDeatails {
  description: "توضیحات";
  ladingLocationAddress: "ععب";
  orderDate: "1403/06/06";
  companyTel: null;
  companyAddress: null;
  orderCode: null;
  id: "66cdc027a5cd1da174714f96";
  orderId: "209995303418";
  loaderTypeName: null;
  goodsName: "نارنج";
  source: "تهران";
  sourceCode: 0;
  destination: "کرمان";
  destinationCode: 0;
  fare: 16500000;
  ladingDate: "1403/06/06";
  ladingDateTo: "1403/06/06";
  ladingTime: "16:16";
  ladingTimeTo: "19:19";
  companyCode: "1100111";
  companyName: "شرکت پیرامید";
  packageTypeName: null;
  weight: 15000;
  remainder: 10;
  nobatCountRemainder: 8;
  terminalName: null;
  salonCode: 0;
  salonName: "سالن ورودی یک";
  loaderTypeGroup: "اطاقدار تک";
  truckCount: 0;
  nobatCount: 0;
  orderSalonType: null;
  orderSalonTypeInt: null;
  loaderTypeGroupSec: null;
  truckWeight: 0;
  truckWeightTo: 0;
  fareAmountPerKg: null;
  reserved: 0;
  referenceCode: null;
  truckCountCompany: null;
  ladingLocationInfoCityName: null;
  ladingLocationInfoAddress: null;
  orderDateEn: null;
  receiverInfoName: null;
}

export default function TenderOfferDetailsPage() {
  const [hasScroll] = useState(false);

  const theme = useTheme();

  const [editable, setEditable] = useState(false);

  const [removeModal, setRemoveModal] = useState(false);

  const [tenderDeatails, setTenderDeatails] = useState<ITenderOfferDeatails>(
    {} as ITenderOfferDeatails
  );

  const { orderId } = useParams();

  const dispatch = useAppDispatch();

  const {
    // data: singleTender,
    trigger: getSingleTender,
    // isMutating: isgetActiveCargoMutting,
  } = useSWRMutation(
    [`/Order/GetById`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setTenderDeatails(data);
      },
    }
  );

  useEffect(() => {
    getSingleTender({
      id: orderId,
    });
  }, []);

  return (
    <>
      <RemoveTenderModal
        open={removeModal}
        setOpen={setRemoveModal}
        orderId={orderId}
      />
      <MobileHeader title={HeadTitle()} hasScroll={hasScroll} />
      <Box
        sx={{
          flex: 1,
          paddingX: "8px",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            padding: "10px",
            borderStyle: "solid",
            borderColor: "info.main",
            borderWidth: "1px",
            borderRadius: "10px",
          }}
        >
          <TenderIfo {...tenderDeatails} />
          <Box
            sx={{
              mt: 2,
              padding: "6px",
              backgroundColor: theme.palette.primary[50],
              borderRadius: "8px",
              gap: "4px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <InfoCircle color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
              }}
              color="primary.main"
            >
              تا زمانی که بار به راننده‌‌ای اختصاص پیدا نکرده، مبلغ پیشنهادی شما
              فعال است و بعد به صورت خودکار حذف می‌شود.
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                borderWidth: "1px",
                borderColor: "info.light",
                borderStyle: "solid",
                padding: "8px 4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <BigCar3 color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  گروه بارگیر:
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
                color="secondary.main"
              >
                {tenderDeatails?.loaderTypeGroup}
              </Typography>
            </Box>
            <Box
              sx={{
                borderWidth: "1px",
                borderColor: "info.light",
                borderStyle: "solid",
                padding: "8px 4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <DolorSingle color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  کرایه اعلام شده بار:
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                  color="success.main"
                >
                  {addCommas(tenderDeatails?.fare || 0)} ریال
                </Typography>
              </Box>
            </Box>

            {editable ? (
              <>
                <Box
                  sx={{
                    borderWidth: "1px",
                    borderColor: "info.light",
                    borderStyle: "solid",
                    padding: "8px 4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: "8px",
                    backgroundColor: "info.light",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <ArrowUpFillSVG color={theme.palette.textColor.main} />
                    <Typography variant="body2"> آخرین پیشنهاد شما:</Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1" color="primary.main">
                      {addCommas(80000000)}
                    </Typography>
                    <Typography color="primary.main">ریال</Typography>
                  </Box>
                </Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  color={"secondary.main"}
                >
                  کرایه پیشنهادی جدید خود را وارد کنید
                </Typography>
                <Box
                  sx={{
                    borderRadius: "10px",
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor: "info.light",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    type="number"
                    placeholder="-----"
                    sx={{
                      textAlign: "left",
                      direction: "ltr",
                      flex: 1,
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important",
                        outline: "none !important",
                      },
                      "& .MuiInputBase-input": {
                        //   border: "none !important",
                        outline: "none !important",
                      },
                      "& .MuiInputBase-root": {
                        border: "none !important",
                        outline: "none !important",
                      },
                      border: "none",
                    }}
                  />
                  <Typography width={"45%"}>ریال</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <CustomButton
                    rippleColor={theme.palette.info.dark}
                    flex={1}
                    // loading
                    justifyContent="center"
                    flexDirection="row-reverse"
                    onClick={() => setEditable(true)}
                    title="تایید و ارسال جدید"
                    bgColor="success.main"
                    px="10px"
                    py="12px"
                    borderRadius="10px"
                    icon1={<EditFillSVG size={22} color={"#fff"} />}
                  />
                  <CustomButton
                    type="outlined"
                    rippleColor={theme.palette.info.dark}
                    // loading
                    //   flexDirection="row-reverse"
                    onClick={() => setEditable(false)}
                    title="انصراف"
                    bgColor={theme.palette.primary[50]}
                    textColor="primary.main"
                    borderColor="primary.main"
                    px="10px"
                    py="12px"
                    borderRadius="10px"
                    icon2={
                      <MultipleSimple
                        color={theme.palette.primary.main}
                        size={18}
                      />
                    }
                  />
                </Box>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    borderWidth: "1px",
                    borderColor: "info.light",
                    borderStyle: "solid",
                    padding: "8px 4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: "8px",
                    backgroundColor: theme.palette.primary[50],
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <ArrowUpFillSVG color={theme.palette.textColor.main} />
                    <Typography
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      کرایه پیشنهادی شما:
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                    color="primary.main"
                  >
                    {digitsEnToFa(addCommas(80000000))} ریال
                  </Typography>
                </Box>
                <CustomButton
                  rippleColor={theme.palette.info.dark}
                  flex={1}
                  // loading
                  justifyContent="center"
                  onClick={() => setEditable(true)}
                  title="ویرایش پیشنهاد"
                  bgColor="primary.main"
                  textColor="#fff"
                  fSize="16px"
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  icon1={<EditFillSVG size={22} />}
                />
                <CustomButton
                  type="outlined"
                  rippleColor={theme.palette.info.dark}
                  flex={1}
                  onClick={() => setRemoveModal(true)}
                  justifyContent="center"
                  title="حذف پیشنهاد"
                  bgColor="error.light"
                  textColor="error.main"
                  borderColor="error.main"
                  fWeight="700"
                  fSize="16px"
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  icon1={
                    <MultipleSimple
                      color={theme.palette.error.main}
                      size={18}
                    />
                  }
                />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 600,
        }}
      >
        مناقصات بار{" "}
      </Typography>
      <ArrowTickLeft size={14} color={theme.palette.textColor.main} />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        جزئیات مناقصه{" "}
      </Typography>
    </Box>
  );
}
